import { Navigate, Outlet } from 'react-router-dom';

import { LoadingState } from '../components/index.js';
import { useCurrentUser } from '../lib/auth.js';

/** UX guard only; every admin API endpoint independently enforces the role. */
export function AdminRoute() {
  const currentUser = useCurrentUser();
  if (currentUser.isPending) return <LoadingState label="Checking administrator access…" />;
  if (currentUser.data?.role !== 'admin') return <Navigate to="/" replace />;
  return <Outlet />;
}
